import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import emitter, { MODAL_TYPES, SWIPER_ACTIONS } from "../../utils/emitter";
import useController from "./controller";
import is from "is_js";
import i18n from "i18next";
import "./style.scss";

import { Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import NextSlideBtn from "./NextSlideBtn";
import PrevSlideBtn from "./PrevSlideBtn";
import config from "../../config";
import SwiperMarathonModalTitle from "./SwiperModalTItle";
import SelectCard from "./SelectCard";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import BaseSwiperModal from "../../components/BaseModal/components/BaseSwiperModal";
import GetStaticCardAction from "../../utils/get-static-card-action";
import { useTranslation } from "react-i18next";
import BaseIcon from "../../components/BaseIcon";
import BaseSpinner from "../../components/BaseSpinner";
import { demonstrationStore } from "../../store/Demonstration";
import { shopStore } from "../../store/Shop";
import { shouldPulseShopIcon } from "../../utils/shopProducts";

export default observer(function SwiperModal({
  gameFormat,
  selectCard,
  disabledClick,
  onClickInsightForm,
  isInsightLoading,
  onSelectConfig = {
    slideOnSelect: true,
  },
}) {
  SwiperModal.propTypes = {
    gameFormat: PropTypes.oneOf(["marathon", "compromise", ""]),
    selectCard: PropTypes.func,
    isInsightLoading: PropTypes.bool,
    onSelectConfig: PropTypes.object,
  };
  const { t } = useTranslation();
  const {
    onPayloadHandle,
    slides,
    initialCard,
    currentSlideCount,
    onSwipeChange,
    onSelectSlide,
  } = useController();
  const isOneSlide = slides.length === 1;
  const { isCurrentUserMale } = useCurrentUserData();

  const refCard = useRef();

  const [swiper, setSwiper] = useState();

  useEffect(() => {
    if (swiper && demonstrationStore.isOpen) {
      const targetSlide = Array.from(swiper.wrapperEl.children).find(
        (slide) => {
          const index = slide.getAttribute("data-swiper-slide-index");
          return parseInt(index, 0) === initialCard?.id;
        }
      );
      if (targetSlide) {
        if (demonstrationStore.step === 2) {
          refCard.current = targetSlide.querySelector(
            ".modal-swiper-card__insight-icon"
          ).children[0];
          demonstrationStore.setRefCard(refCard);
        } else if (demonstrationStore.step === 3) {
          demonstrationStore.checkCard();
          refCard.current = targetSlide.querySelector(
            ".modal-swiper-card__card-wrapper"
          ).children[0];
          demonstrationStore.setRefCard(refCard);
        } else if (demonstrationStore.step === 4) {
          const shopEl = targetSlide.querySelector(
            ".modal-swiper-card__bottom-icons__shop"
          );
          if (shopEl && shopEl.children[0]) {
            refCard.current = shopEl.children[0];
            demonstrationStore.setRefCard(refCard);
          }
        }
      }
    }
  }, [swiper, demonstrationStore.step, demonstrationStore.isOpen]);

  const isDemonstrationStep3 =
    demonstrationStore.isOpen &&
    demonstrationStore.step === 3 &&
    demonstrationStore.isCheckedCard;

  const select = (card) => {
    if (disabledClick) {
      return;
    }
    selectCard(card);
    if (onSelectConfig && onSelectConfig?.slideOnSelect) {
      emitter.emit(SWIPER_ACTIONS.SHOW_NEXT_SLIDE, card);
    }
    onSelectSlide(card);
  };

  const getTitle = (card) => {
    if (card?.question) return card.question;
    if (isCurrentUserMale()) {
      return card?.question_for_male ?? i18n.language === "ru"
        ? card.m_ru
        : card.m_en;
    } else {
      return card?.question_for_female ?? i18n.language === "ru"
        ? card.f_ru
        : card.f_en;
    }
  };
  const onSwiperInit = (swiper) => {
    setSwiper(swiper);
  };

  return (
    <BaseSwiperModal
      className="swiper-cards-modal"
      onPayload={onPayloadHandle}
      eventTypeModal={MODAL_TYPES.SWIPER}
      title={
        <SwiperMarathonModalTitle
          gameFormat={gameFormat}
          count={`${currentSlideCount}/${slides.length}`}
        />
      }
      titleStyle="swiper-cards-modal__title"
      contentStyle="swiper-cards-modal__content"
    >
      <Swiper
        onVirtualUpdate={onSwiperInit}
        className={`${isOneSlide && "swiper-one-card-fix"}`}
        virtual={true}
        slidesPerView={1}
        initialSlide={initialCard?.id}
        modules={[Virtual]}
        onSlideChange={onSwipeChange}
        watchOverflow={true}
        longSwipes={true}
        shortSwipes={false}
      >
        <div className="swiper-cards-modal__swiper-buttons">
          <PrevSlideBtn isOneSlide={isOneSlide} />
          <NextSlideBtn />
        </div>
        {slides.map((card, i) => {
          return (
            <SwiperSlide
              className={`${isOneSlide && "swiper-slide-one-card-fix"}`}
              onClick={(e) => {
                e.stopPropagation();
                selectCard && select(card);
              }}
              key={i}
              virtualIndex={i}
            >
              <div>
                <div className="modal-swiper-card">
                  <div
                    className={`modal-swiper-card__card-wrapper ${
                      (card.selected || card?.isCheckedZone) && "no-hover"
                    }`}
                  >
                    {(gameFormat === "marathon" ||
                      demonstrationStore.isOpen) && (
                      <SelectCard
                        className="modal-swiper-card__card-wrapper__select no-hover__select"
                        selected={
                          (card.selected && !demonstrationStore.isOpen) ||
                          (card?.isCheckedZone && !demonstrationStore.isOpen) ||
                          isDemonstrationStep3
                        }
                        size="medium"
                      />
                    )}
                    {/*{gameFormat === "marathon" && (
                      <StaticCardActionBtn
                        wrapperStyle="modal-swiper-card__card-wrapper__action no-hover__action"
                        type="positive"
                      />
                    )}*/}
                    <img
                      className={`modal-swiper-card__card-wrapper__image no-hover__image ${
                        ((card.selected && !demonstrationStore.isOpen) ||
                          (card?.isCheckedZone && !demonstrationStore.isOpen) ||
                          isDemonstrationStep3) &&
                        "modal-swiper-card__card-wrapper__image_selected"
                      } ${gameFormat !== "marathon" && "no-opacity"} 
                      ${
                        is.safari() &&
                        "modal-swiper-card__card-wrapper__image__mobile-safari"
                      }
                    `}
                      src={
                        card.cardUrl
                          ? `${config.staticApiUrl}${card.cardUrl}`
                          : card.src
                      }
                      alt={card.question}
                    />
                  </div>
                  <div className="modal-swiper-card__name">
                    {getTitle(card)}
                  </div>
                </div>

                {card.your_answer ? (
                  <>
                    <div className="modal-swiper-card__bottom-answers">
                      <div className="modal-swiper-card__bottom-answers__item">
                        {GetStaticCardAction(
                          card.your_answer.answer || card.your_answer
                        )}
                        <div>{t("your_answer")}</div>
                      </div>
                      <div className="modal-swiper-card__bottom-answers__item">
                        {GetStaticCardAction(
                          card.partner_answer.answer || card.partner_answer
                        )}
                        <div>{t("partner_answer")}</div>
                      </div>
                    </div>
                  </>
                ) : null}
                <div className="modal-swiper-card__divider">
                  <div className="modal-swiper-card__dash-line"></div>
                </div>
                <div className="modal-swiper-card__bottom-icons">
                  <div className="modal-swiper-card__bottom-icons__item modal-swiper-card__bottom-icons__info">
                    <BaseIcon
                      name="info_icon"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    />
                  </div>
                  <div className="modal-swiper-card__insight-icon modal-swiper-card__bottom-icons__item">
                    {isInsightLoading ? (
                      <BaseSpinner />
                    ) : (
                      <BaseIcon
                        onClick={(event) => {
                          event.stopPropagation();
                          onClickInsightForm(card);
                        }}
                        name="insight_form_icon"
                      />
                    )}
                  </div>
                  <div
                    className={`modal-swiper-card__bottom-icons__item modal-swiper-card__bottom-icons__shop ${
                      shouldPulseShopIcon(shopStore.selectedCountry, card)
                        ? "modal-swiper-card__bottom-icons__shop--pulse"
                        : ""
                    }`}
                  >
                    <BaseIcon
                      name="shop_icon2"
                      onClick={(event) => {
                        event.stopPropagation();
                        shopStore.open(card);
                      }}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </BaseSwiperModal>
  );
});
